import moment from 'moment'
import {
  buildOccurrences,
  formatDutyRange,
  repeatDayOptions,
} from '../../../patientTransport/Duties/CreateDuty/dutyRepeat'
import { resizeSlots, slotToPayload } from './ShiftSlotAssignments'

// Mirrors MAX_REPEAT_OCCURRENCES / MAX_REPEAT_SHIFTS in
// server/src/helpers/scheduling/eventShiftRepeat.js
export const MAX_REPEAT_OCCURRENCES = 100
export const MAX_REPEAT_SHIFTS = 400

// Same local-time expansion as repeating a PTS duty: one occurrence per
// matching day, keeping the shift's wall-clock times and any overnight span
export { buildOccurrences, repeatDayOptions }
export const formatShiftRange = formatDutyRange

// Repeat until the event's last day when it runs over several days (the usual
// case - a festival or a season), otherwise for a week
export const defaultShiftRepeat = (start, eventEnd) => {
  const first = moment(start).startOf('day')
  const last = eventEnd ? moment(eventEnd).startOf('day') : null
  return {
    enabled: false,
    daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
    intervalWeeks: 1,
    until:
      last?.isValid() && last.isAfter(first, 'day')
        ? last
        : first.clone().add(6, 'days'),
    sameStaff: true,
    // { [occurrence.key]: slots[] } - only used when sameStaff is off
    assignments: {},
  }
}

// Who covers each shift on a given day. With "same staff" on every day copies
// the slots picked in the Assignment section; otherwise the first day starts
// with them and later days start as open vacancies until assigned.
export const getOccurrenceSlots = (
  repeat,
  occurrence,
  occurrenceIndex,
  slots,
  quantity,
) => {
  if (repeat?.sameStaff) return resizeSlots(slots, quantity)
  const own = repeat?.assignments?.[occurrence.key]
  if (own) return resizeSlots(own, quantity)
  return resizeSlots(occurrenceIndex === 0 ? slots : [], quantity)
}

// Body for POST /events/:eventID/shifts/repeat
export const buildShiftRepeatPayload = ({
  shift,
  repeat,
  occurrences,
  slots,
  quantity,
}) => ({
  shift,
  occurrences: occurrences.map((occurrence, occurrenceIndex) => ({
    start: occurrence.start.toISOString(),
    end: occurrence.end.toISOString(),
    assignments: getOccurrenceSlots(
      repeat,
      occurrence,
      occurrenceIndex,
      slots,
      quantity,
    ).map(slotToPayload),
  })),
})

// Server issues carry `occurrence` + `slot`:
// { [occurrenceIndex]: { [slotIndex]: [issue] } }
export const groupRepeatIssues = (issues) =>
  (issues ?? []).reduce((grouped, issue) => {
    const occurrence = issue?.occurrence ?? 0
    const slot = issue?.slot ?? 0
    grouped[occurrence] = grouped[occurrence] ?? {}
    grouped[occurrence][slot] = [...(grouped[occurrence][slot] ?? []), issue]
    return grouped
  }, {})
